<!--<div class="welcome" *ngIf="!loginDisplay">-->
<!--  <mat-spinner></mat-spinner>-->
<!--</div>-->

<app-auth *ngIf="!loginDisplay"></app-auth>

<ng-container *ngComponentOutlet="activeDashboard"></ng-container>


<ng-template #checkOrgNumberDialog>
  <div class="dialog-wrapper">
    <mat-dialog-content>
    <div class="check-number-header">
      <img class="logo" src="assets/logo.png" alt="logo">
      <h1 class="text-black font-weight-600">Check company registration number</h1>
      <p>Enter the company registration number in the entry field</p>
    </div>
    <div class="form-control">
      <mat-form-field>
        <input #input type="text" matInput [required]="true" placeholder="Registration number">
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <button style="color: white" class="btn" mat-button [disabled]="!input.value" (click)="checkOrganizationNumber(input.value)">Confirm</button>
  </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #confirmCompanyJoinDialog>
  <div class="dialog-wrapper">
  <mat-dialog-content>
    <div class="check-number-header">
      <img class="logo" src="assets/logo.png" alt="logo">
      <h1 class="text-black font-weight-600">Do you want to join the company?</h1>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <button style="color: white" class="btn-join" mat-button (click)="onReject()">Cancel</button>
    <button style="color: white" class="btn-join" (click)="onConfirmJoin()" mat-button>Confirm</button>
  </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #newCompanyDialog>
  <div class="dialog-wrapper">
  <mat-dialog-content>
    <div class="check-number-header">
      <img class="logo" src="assets/logo.png" alt="logo">
      <h1 class="text-black font-weight-600">Do you want to create a company?</h1>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <button style="color: white" class="btn-join" mat-button (click)="onReject()">Cancel</button>
    <button style="color: white" class="btn-join" (click)="onCompanyCreate()" mat-button>Confirm</button>
  </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #companySelectDialog>
  <div class="dialog-wrapper">
    <div class="dialog-header" mat-dialog-title>
      <button (click)="dialog.closeAll()" mat-icon-button>
        <mat-icon>
          clear
        </mat-icon>
      </button>
    </div>
    <mat-dialog-content>
      <div class="check-number-header">
        <img class="logo" src="assets/logo.png" alt="logo">
        <h1 class="text-black font-weight-600">Please, select a company</h1>
        <mat-form-field>
          <mat-select (valueChange)="onCompanySelect($event)">
            <mat-option *ngFor="let option of companies | sortBy:'name'" [value]="option.id">
              {{option.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="actions">
      <button style="color: white" class="btn-join" mat-button (click)="dialog.closeAll()">Cancel</button>
      <button style="color: white" class="btn-join" (click)="goToModules()" mat-button>Confirm</button>
    </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #moduleSelectDialog>
  <div class="dialog-wrapper">
    <div class="dialog-header" mat-dialog-title>
      <button (click)="dialog.closeAll()" mat-icon-button>
        <mat-icon>
          clear
        </mat-icon>
      </button>
    </div>
    <mat-dialog-content>
      <div class="check-number-header">
        <img class="logo" src="assets/logo.png" alt="logo">
        <h1 class="text-black font-weight-600">Please, select a module</h1>
        <mat-form-field>
          <mat-select
            (ngModelChange)="onModuleSelect($event)"
            [(ngModel)]="selectedModule">
            <mat-option *ngxPermissionsOnly="['CorporateUser']" [value]="1">
              Home
            </mat-option>
            <mat-option *ngxPermissionsOnly="['InvoicingUser']" [value]="2">
              Invoicing
            </mat-option>
            <mat-option *ngxPermissionsOnly="['ComplianceUser']" [value]="3">
              Compliance
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="actions">
      <button style="color: white" class="btn-join" mat-button (click)="dialog.closeAll()">Cancel</button>
      <button style="color: white" class="btn-join" (click)="selectModule()" mat-button>Confirm</button>
    </mat-dialog-actions>
  </div>
</ng-template>
